const CHECKBOX_STATES = {
  TRUE: true,
  FALSE: false,
  INDETERMINATE: 'indeterminate',
};

export { CHECKBOX_STATES };
